// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.
/** dom.ts — tiny helpers. No framework; the UI is a handful of screens. */

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className?: string,
  html?: string,
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (html !== undefined) node.innerHTML = html;
  return node;
}

export function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string
  ));
}

export function button(label: string, className = 'btn'): HTMLButtonElement {
  const b = el('button', className);
  b.type = 'button';
  b.textContent = label;
  return b;
}

/** Show/hide via the `hidden` attribute. `[hidden]{display:none!important}` backs it. */
export function setHidden(node: HTMLElement, hidden: boolean): void {
  if (hidden) node.setAttribute('hidden', '');
  else node.removeAttribute('hidden');
}

export function fmt(n: number): string {
  return n.toLocaleString('en-US');
}